import { TranslationFunctionType } from '@/common/types';
import { array, boolean, object, string } from 'yup';

const visibilityRuleSchema = (t: TranslationFunctionType) =>
  object({
    id: string().required(),
    filterBy: string().required(t('error.requiredField')),
    operator: string().required(t('error.requiredField')),
    product: array().of(string()).min(1, t('error.requiredField')),
    status: array().when('filterBy', {
      is: 'status',
      then: (schema) => schema.min(1, t('error.requiredField')),
      otherwise: (schema) => schema,
    }),
    dateValue: string()
      .nullable()
      .when('filterBy', {
        is: (val: string) =>
          val === 'onboarding-date' || val === 'account-creation-date',
        then: (schema) => schema.required(t('error.requiredField')),
        otherwise: (schema) => schema.nullable(),
      }),
  });

export const adminTaskSchema = (t: TranslationFunctionType) =>
  object({
    title: string().required(t('error.requiredField')),
    description: string().required(t('error.requiredField')),
    buttonName: string().required(t('error.requiredField')),
    buttonUrl: string().required(t('error.requiredField')),
    taskLanguage: string().required(t('error.requiredField')),
    visibilityRulesEnabled: boolean(),
    visibilityRules: array().when('visibilityRulesEnabled', {
      is: true,
      then: (schema) => schema.of(visibilityRuleSchema(t)),
      otherwise: (schema) => schema,
    }),
  });
